import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
export var ItemsCarousel = function ItemsCarousel(_a) {
  var ItemsCarousel = _a.ItemsCarousel,
    restProps = __rest(_a, ["ItemsCarousel"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setMountedFlag = _useState2[1];
  useEffect(function () {
    setMountedFlag(true);
  }, []);
  if (!isMounted || !ItemsCarousel) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ItemsCarousel, Object.assign({}, restProps));
};
export default withComponentDependency(ItemsCarousel);